module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-full"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notesContent),
      expression: "notesContent"
    }],
    ref: "notes-student",
    staticClass: "text-sm border relative h-60 border-coolGray-200 text-gray-500 outline-none px-4 py-3 w-full rounded",
    attrs: {
      "id": "notes-textbox",
      "placeholder": "Take notes before and during the discussion.",
      "type": "text"
    },
    domProps: {
      "value": (_vm.notesContent)
    },
    on: {
      "keyup": _vm.queueSaving,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notesContent = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex justify-end"
  }, [_c('button', {
    ref: "btnRef",
    staticClass: "px-4 pt-2 pb-1 hover:bg-gray-100 rounded cursor-pointer text-gray-400 font-semibold flex items-center justify-center outline-none",
    on: {
      "click": [function($event) {
        return _vm.togglePopover()
      }, function($event) {
        _vm.show_stems = true
      }]
    }
  }, [_c('img', {
    staticClass: "px-1",
    attrs: {
      "src": "/static/ld-sentence-stems.svg"
    }
  }), _vm._v("\n        Stems\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: ({
        exclude: ['btnRef'],
        handler: 'closeStems',
      }),
      expression: "{\n          exclude: ['btnRef'],\n          handler: 'closeStems',\n        }"
    }],
    ref: "popoverRef",
    staticClass: "bg-white w-max max-w-lg border mr-3 block z-50 font-normal leading-normal text-sm text-left no-underline break-words rounded-lg h-96 overflow-y-auto",
    class: {
      hidden: !_vm.popoverShow,
      block: _vm.popoverShow
    }
  }, [_c('div', [_c('div', {
    staticClass: "p-3"
  }, [_c('div', {
    staticClass: "text-left overflow-y-scroll"
  }, [_c('div', {
    staticClass: "my-3"
  }, [_c('p', {
    staticClass: "text-left font-semibold text-primary"
  }, [_c('i', {
    staticClass: "fas fa-play mr-1"
  }), _vm._v(" " + _vm._s(_vm.$t('new_idea')) + "\n                ")]), _vm._v(" "), _vm._l((_vm.default_new_idea_sentences), function(sentence, index) {
    return _c('ul', {
      key: index,
      staticClass: "py-1"
    }, [(sentence.is_active) ? _c('li', {
      staticClass: "flex center pl-0 hover:bg-gray-300 cursor-pointer"
    }, [(sentence.is_custom) ? _c('span', {
      staticClass: "text-sm leading-6",
      on: {
        "click": function($event) {
          return _vm.addStemToNotes(sentence.sentence)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(sentence.sentence))]) : _c('span', {
      staticClass: "text-sm leading-6",
      on: {
        "click": function($event) {
          _vm.addStemToNotes(_vm.$t('stem_new_' + index))
        }
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.$t('stem_new_' + index)) + "\n                    ")])]) : _vm._e()])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "my-3"
  }, [_c('p', {
    staticClass: "text-left font-semibold text-green-700"
  }, [_c('i', {
    staticClass: "fas fa-square mr-1.5"
  }), _vm._v(_vm._s(_vm.$t('build_on')) + "\n                ")]), _vm._v(" "), _vm._l((_vm.default_build_on_sentences), function(sentence, index) {
    return _c('ul', {
      key: index,
      staticClass: "py-1"
    }, [(sentence.is_active) ? _c('li', {
      staticClass: "flex center pl-0 hover:bg-gray-300 cursor-pointer"
    }, [(sentence.is_custom) ? _c('span', {
      staticClass: "text-sm leading-6",
      on: {
        "click": function($event) {
          return _vm.addStemToNotes(sentence.sentence)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(sentence.sentence))]) : _c('span', {
      staticClass: "text-sm leading-6",
      on: {
        "click": function($event) {
          _vm.addStemToNotes(_vm.$t('stem_build_' + index))
        }
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.$t('stem_build_' + index)) + "\n                    ")])]) : _vm._e()])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "my-3"
  }, [_c('p', {
    staticClass: "text-left font-semibold text-pinky"
  }, [_c('i', {
    staticClass: "fas fa-circle mr-1.5"
  }), _vm._v(_vm._s(_vm.$t('challenge')) + "\n                ")]), _vm._v(" "), _vm._l((_vm.default_challenge_sentences), function(sentence, index) {
    return _c('ul', {
      key: index,
      staticClass: "py-1"
    }, [(sentence.is_active) ? _c('li', {
      staticClass: "flex center pl-0 hover:bg-gray-300 cursor-pointer"
    }, [(sentence.is_custom) ? _c('span', {
      staticClass: "text-sm leading-6",
      on: {
        "click": function($event) {
          return _vm.addStemToNotes(sentence.sentence)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(sentence.sentence))]) : _c('span', {
      staticClass: "text-sm leading-6",
      on: {
        "click": function($event) {
          _vm.addStemToNotes(_vm.$t('stem_challenge_' + index))
        }
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.$t('stem_challenge_' + index)) + "\n                    ")])]) : _vm._e()])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "my-3"
  }, [_c('p', {
    staticClass: "text-left font-semibold text-darkBlue-dark flex"
  }, [_c('img', {
    staticClass: "-ml-0.5 mr-1 h-5 w-5",
    attrs: {
      "src": "/static/live_discussion/ld_question_icon.svg"
    }
  }), _vm._v("\n                  " + _vm._s(_vm.$t('question')) + "\n                ")]), _vm._v(" "), _vm._l((_vm.default_question_sentences), function(sentence, index) {
    return _c('ul', {
      key: index,
      staticClass: "py-1"
    }, [(sentence.is_active) ? _c('li', {
      staticClass: "flex center pl-0 hover:bg-gray-300 cursor-pointer"
    }, [(sentence.is_custom) ? _c('span', {
      staticClass: "text-sm leading-6",
      on: {
        "click": function($event) {
          return _vm.addStemToNotes(sentence.sentence)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(sentence.sentence))]) : _c('span', {
      staticClass: "text-sm leading-6",
      on: {
        "click": function($event) {
          _vm.addStemToNotes(_vm.$t('stem_question_' + index))
        }
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.$t('stem_question_' + index)) + "\n                    ")])]) : _vm._e()])
  })], 2)])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-80269b1a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/Participants/StudentMakeNotes.vue
// module id = 1844
// module chunks = 61